import { render, staticRenderFns } from "./qr.vue?vue&type=template&id=4ecc2799&scoped=true&"
import script from "./qr.vue?vue&type=script&lang=js&"
export * from "./qr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecc2799",
  null
  
)

export default component.exports